"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var EditableColumnComponent_1 = __importDefault(require("./EditableColumnComponent"));
var actions_1 = require("../../../actions");
var Column_1 = __importDefault(require("../Column"));
var mapState = function (_a, _b) {
    var _c;
    var grid = _a.grid;
    var gridname = _b.grid, rowId = _b.rowId, colId = _b.colId, rowData = _b.rowData, idx = _b.idx;
    return ({
        rowInEdit: grid[gridname].edit
            && grid[gridname].edit.rowId === rowId
            || false,
        cellInEdit: grid[gridname].edit
            && grid[gridname].edit.rowId === rowId
            && grid[gridname].edit.colId === colId
            || false,
        submitStatus: grid[gridname].edit
            && grid[gridname].edit.status
            && grid[gridname].edit.status[rowId]
            && grid[gridname].edit.status[rowId][colId]
            || null,
        changedRowData: grid[gridname].edit
            && grid[gridname].edit.values
            && grid[gridname].edit.values[rowId]
            && grid[gridname].edit.values[rowId].hasOwnProperty(colId)
            && __assign(__assign({}, rowData), (_c = {}, _c[idx] = grid[gridname].edit.values[rowId][colId], _c))
            || null,
        hasValueChanged: grid[gridname].edit
            && grid[gridname].edit.values
            && grid[gridname].edit.values[rowId]
            && grid[gridname].edit.values[rowId].hasOwnProperty(colId)
            || false
    });
};
var mapDispatch = function (dispatch, _a) {
    var grid = _a.grid, rowId = _a.rowId, colId = _a.colId;
    return ({
        onClick: function () { return dispatch((0, actions_1.editStart)(grid, rowId, colId)); },
        // @ts-ignore
        onBlur: function () { return dispatch((0, actions_1.editEnd)(grid, rowId, colId)); }
    });
};
var EditableColumnContainer = (0, react_redux_1.connect)(mapState, mapDispatch)(EditableColumnComponent_1["default"]);
exports["default"] = (function (_a) {
    var _b = _a.formComponent, formComponent = _b === void 0 ? 'input' : _b, 
    // @ts-ignore
    _c = _a.component, 
    // @ts-ignore
    component = _c === void 0 ? Column_1["default"] : _c, rest = __rest(_a, ["formComponent", "component"]);
    return (
    // @ts-ignore
    react_1["default"].createElement(EditableColumnContainer, __assign({ formComponent: formComponent, component: component }, rest)));
});
